import React, { Component } from 'react'
import { Row, Field, Label, Select, TextArea, Button }  from '../../generic'
import { ToolTip } from '../../forms/eventFormComponents'
import TextInput from '../../generic/fields/TextInput'
import RadioInput from '../../generic/fields/RadioInput'
import DatePicker from '../../generic/fields/DatePicker'
import Uploader from '../../generic/fields/Uploader'
import { validRadio, word_wrap } from '../../../helpers/check-required-fields'
import { hashToUri } from '../../../helpers/util'
import styled from 'styled-components'

const Hint = styled.div`
  color: rgba(0,0,0,0.6);
  margin-top: 7px;
  margin-bottom: 7px;
`

class SaveTheDate extends Component {
  render() {
    const { userEvent, onChange } = this.props
    const previewParams = {
      type: 'savethedate',
      date: userEvent.invitation_date || '2030-01-01',
      from: userEvent.save_the_date_from || '',
      message: userEvent.save_the_date_message || '',
      image: userEvent.invitation_logo || '',
    }

    const invalidMessage = userEvent.save_the_date_message && word_wrap(userEvent.save_the_date_message, 50).split("\n").length > 8

    return (
      <React.Fragment>
        <h1>Create Your Save the Date Card</h1>
        <p style={{ maxWidth: '550px' }}>Fill in the information below and we'll create a custom save the date card that you can print or share.</p>
        <p style={{ maxWidth: '550px', marginBottom: '20px' }}>After you complete this area, your custom card image will be ready to download and print or share by email/social media.</p>
        <Row className="twoCol">
          <div>
            <Field name="userEvent[invitation_date]" error={false}>
              <Label value="Event Date" required={true} />
              <DatePicker value={userEvent.invitation_date} onChange={onChange} />
            </Field>
            <Field name="userEvent[save_the_date_from]" error={false}>
              <Label value="From (optional)" required={false} />
              <TextInput style={{ maxWidth: '450px' }} value={userEvent.save_the_date_from} onChange={onChange} />
            </Field>
            <Field name="userEvent[save_the_date_message]" error={invalidMessage}>
              <Label value="Personal Message (optional)" />
              <>{invalidMessage && <p style={{ color: 'red' }}>Messages are limited to 8 lines, please reduce the length of your message.</p>}</>
              <TextArea style={{ maxWidth: '450px' }} rows={5} value={userEvent.save_the_date_message} onChange={onChange} />
            </Field>
            <Field style={{ marginBottom: '35px' }} name="userEvent[invitation_logo]" error={false}>
              <Label value="Optional: upload a logo image (less than 2MB)" />
              <Hint>JPG or PNG file only</Hint>
              <Uploader value={userEvent.invitation_logo} onChange={onChange} />
            </Field>
          </div>
          <div>
            <a style={{ display: 'block', textAlign: 'center' }} href={`/api/image?${hashToUri({...previewParams, dl: 1 })}`}>
              <div><img style={{ width: '100%' }} src={`/api/image?${hashToUri(previewParams)}`}/></div>
              <Button style={{ marginTop: '10px', marginBottom: '40px' }} type="button">Download Card</Button>
            </a>
          </div>
        </Row>
      </React.Fragment>
    )
  }
}

export default SaveTheDate
